import {dbComun} from '../bases-datos'

export const obtenerVersionActual = async (nuevaVersion) => {
  if (nuevaVersion) return 0
  let version = await dbComun.table('Version').toArray()
  return version?.[0]?.Numero ?? 0
}
